import { render, staticRenderFns } from "./QuestionForm.vue?vue&type=template&id=1b48add3"
import script from "./QuestionForm.vue?vue&type=script&lang=js"
export * from "./QuestionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b48add3')) {
      api.createRecord('1b48add3', component.options)
    } else {
      api.reload('1b48add3', component.options)
    }
    module.hot.accept("./QuestionForm.vue?vue&type=template&id=1b48add3", function () {
      api.rerender('1b48add3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/questions/QuestionForm.vue"
export default component.exports